import type { NOTIFICATION_CHANNEL } from "@nlc/shared-types";

import { useMutation, useQueryClient } from "@tanstack/react-query";

import { notificationsKeys } from "@/hooks/queryKeys";
import apiClient from "@/lib/api/client";

export function useDisconnectChannel() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (channel: NOTIFICATION_CHANNEL) =>
      apiClient.url(`/users/me/channels/${channel}`).delete().res(),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: notificationsKeys.settings() });
    },
  });
}
